/**
 * Environment-driven cache configuration.
 *
 * Controls whether TanStack Query caching is active and how long
 * responses are considered fresh before a background refetch is triggered.
 *
 * | Env Var                        | Default   | Description                          |
 * |-------------------------------|-----------|--------------------------------------|
 * | REACT_APP_CACHE_ENABLED       | "true"    | Global cache on/off ("true"/"false") |
 * | REACT_APP_CACHE_STALE_TIME    | 120000    | Stale time in milliseconds           |
 */

const envEnabled = process.env.REACT_APP_CACHE_ENABLED;
const envStaleTime = process.env.REACT_APP_CACHE_STALE_TIME;

// Validate REACT_APP_CACHE_ENABLED — must be "true" or "false" (case-insensitive).
// Defaults to false for any unset or unrecognized value.
if (
  envEnabled !== undefined &&
  !["true", "false"].includes(envEnabled.toLowerCase())
) {
  console.warn(
    `Invalid REACT_APP_CACHE_ENABLED value: "${envEnabled}". Defaulting to false.`
  );
}

/** Whether caching is globally enabled. Defaults to `false`. */
export const CACHE_ENABLED: boolean = envEnabled?.toLowerCase() === "true";

/** Default stale time (ms). Defaults to 2 minutes. */
export const CACHE_STALE_TIME: number = Number(envStaleTime) || 1000 * 60 * 2;

/** Default garbage-collection time (ms). Keeps a 2.5× ratio to staleTime, minimum = staleTime. */
export const CACHE_GC_TIME: number = Math.max(
  CACHE_STALE_TIME,
  Math.round(CACHE_STALE_TIME * 2.5)
);
